import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface INoteBookingAttributes extends IModelAttributes {
	noteId: string;
	bookingId: string;

	note: Models.NotesEntity | Models.INotesEntityAttributes;
	booking: Models.BookingEntity | Models.IBookingEntityAttributes;
}

@entity('NoteBooking')
export default class NoteBooking extends Model implements INoteBookingAttributes {
	@observable
	@attribute()
	public noteId: string;

	@observable
	@attribute()
	public bookingId: string;

	@observable
	@attribute({ isReference: true })
	public note: Models.NotesEntity;

	@observable
	@attribute({ isReference: true })
	public booking: Models.BookingEntity;

	constructor(attributes?: Partial<INoteBookingAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.noteId) {
				this.noteId = attributes.noteId;
			}
			if (attributes.bookingId) {
				this.bookingId = attributes.bookingId;
			}

			if (attributes.note) {
				if (attributes.note instanceof Models.NotesEntity) {
					this.note = attributes.note;
					this.noteId = attributes.note.id;
				} else {
					this.note = new Models.NotesEntity(attributes.note);
					this.noteId = this.note.id;
				}
			} else if (attributes.noteId !== undefined) {
				this.noteId = attributes.noteId;
			}

			if (attributes.booking) {
				if (attributes.booking instanceof Models.BookingEntity) {
					this.booking = attributes.booking;
					this.bookingId = attributes.booking.id;
				} else {
					this.booking = new Models.BookingEntity(attributes.booking);
					this.bookingId = this.booking.id;
				}
			} else if (attributes.bookingId !== undefined) {
				this.bookingId = attributes.bookingId;
			}
		}
	}
}
